export const SHOW_CONTROLS_ON_HOVER = false;

export const SLIDER_OPTIONS = {
    animation: {
        type: 'monoSlider'
    },
    controls: {
        arrows: { enabled: true },
        bullets: {
            enabled: false,
            position: {
                x: 'right',
                y: 'top',
                offsetX: '4rem',
                offsetY: '0.5rem'
            }
        },
        buttons: { enabled: true }
    }
} as const;
